import { render, staticRenderFns } from "./AdminRetailersPage.vue?vue&type=template&id=2acf4c9f&scoped=true"
import script from "./AdminRetailersPage.vue?vue&type=script&lang=js"
export * from "./AdminRetailersPage.vue?vue&type=script&lang=js"
import style0 from "./AdminRetailersPage.vue?vue&type=style&index=0&id=2acf4c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf4c9f",
  null
  
)

export default component.exports